import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import InstagramFeed from "./components/InstagramFeed";
import Services from "./components/Services";
import Brands from "./components/Brands";
import WhyChoose from "./components/WhyChoose";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import BrandServicePage from "./components/BrandServicePage";

const HomePage = () => (
  <>
    <Header />
    <Hero />
    <About />
    <InstagramFeed />
    <Services />
    <Brands />
    <WhyChoose />
    <Gallery />
    <Contact />
    <Footer />
    <WhatsAppButton />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services/:brand" element={<BrandServicePage />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
